import { useMemo } from 'react';
import { PreviousOrderModalProductItem } from '../PreviousOrderModalProductItem/PreviousOrderModalProductItem';
import { IOrderProduct } from '~/types/orders';
import { PRODUCT_TYPE } from '~/types/product';
import { productUtils } from '~/utils/productUtils';

interface IProps {
  product: IOrderProduct;
}

export const PreviousOrderModalProductItems: React.FC<IProps> = ({ product }: IProps): JSX.Element | null => {
  const isMeal = useMemo((): boolean => product.type === PRODUCT_TYPE.MEAL_COMBO, [product.type]);

  if (!product.items?.length) return null;

  return (
    <div>
      {product.items.map((item, index) => (
        <PreviousOrderModalProductItem key={productUtils.getMealItemKey(item, index)} item={item} isMeal={isMeal} />
      ))}
    </div>
  );
};
